import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import store from "../../../App/store";
import { setCart } from "@/redux/actions/cartActions";
import { connect } from "react-redux";
import { getMerchantRedeemable } from "@/services/program/getMerchantRedeemable";
import { getAuthCart, updateAuthCart } from "@/containers/App/auth";
import TemplateButton from "@/shared/components/TemplateButton";
import { useTranslation } from "react-i18next";
import { getRedemptionValue, DEFAULT_CURRENCY } from "@/shared/helpers";
import { getMerchant } from "@/services/program/getMerchant";
import "@/containers/Participant/GcmShared/redeem.scss";
import { REDEEM_PATH } from "@/containers/Participant/GcmShared/routes";
import { gcmPhotoUrl, yelpBusinessUrl, fillGcmPlaceholders, htmlHasText } from "@/containers/Participant/GcmShared/helpers";
import { YelpRating } from "@/containers/Participant/GcmShared/yelp";
import { GcmBrand } from "@/containers/Participant/GcmShared/GcmHeader";
import GiftCardImage from "@/shared/components/GiftCardImage";

const Redeem = ({ organization, program, currency }) => {
  const { t } = useTranslation();
  let { merchantId } = useParams();
  const [merchant, setMerchant] = useState(null);
  const [giftcodes, setGiftcodes] = useState([]);
  const [loadingGiftcodes, setLoadingGiftcodes] = useState(true);
  const [selectedGiftcode, setSelectedGiftcode] = useState(null);
  const [addedToCart, setAddedToCart] = useState(false);


  const makeOption = (i, giftcode, factor_valuation, currency) => {
    let giftCode = { ...giftcode, ...merchant };
    let redemption_value = getRedemptionValue(giftCode, merchant.pivot, currency);
    let dollarValue = parseFloat(giftCode.sku_value, 3).toFixed(2);
    let currencySymbol = '$';
    let pointsValue = parseFloat(redemption_value * factor_valuation, 2).toFixed(0);
    if( currency.value !== DEFAULT_CURRENCY.value)  {
      // redemption_value = redemption_value * currency.conversion_rate
      dollarValue = parseFloat(giftCode.sku_value).toFixed(2);
      currencySymbol = currency.symbol;
      pointsValue = parseFloat((1/currency.conversion_rate * redemption_value)  * factor_valuation, 2).toFixed(0);
    }
    let label = `${currencySymbol}${dollarValue} ${t("gift_code")} = ${pointsValue}`;
    if (process.env.REACT_APP_ENV != 'production') {
      // needs to be fixed
      //label += giftcode.virtual_inventory ? ' virtual' : '';
    }
    label += ` ${t('points')}`;

    return {
      label: label,
      value: i++,
    };
  };
  
  useEffect(() => {
    if (organization && program && merchantId) {
      getMerchant(organization.id, program.id, merchantId).then((payload) => {
        setMerchant(payload);
      });
    }
  }, [organization, program, merchantId]);

  // useEffect(() => {
  //   if (organization && program && currency) {
  //     getCurrency(organization.id, program.id, currency.).then((payload) => {
  //       setMerchant(payload);
  //     });
  //   }
  // }, [organization, program, currency]);
  
  useEffect(() => {
    if (organization && program && merchantId) {
      getMerchantRedeemable(organization.id, program.id, merchantId).then(
        (payload) => {
          if (payload && payload.length > 0) {
            setGiftcodes(payload);
          }
          setLoadingGiftcodes(false);
        }
      );
    }
  }, [organization, program, merchantId]);

  const onChangeGiftcode = (value) => {
    // alert(JSON.stringify(value))
    setSelectedGiftcode(value);
    setAddedToCart(false);
  };

  const onClickAddToCart = () => {
    const selectedIndex = selectedGiftcode.value;
    const item = { ...giftcodes[selectedIndex] };
    item.merchant_name = merchant.name;
    item.merchant_icon = merchant.icon;
    item.merchant_image_url = merchant.image_url ?? null;
    // GCM only: shown with the Yelp rating pill in the cart
    item.merchant_rating = merchant.rating ?? null;
    item.merchant_review_count = merchant.review_count ?? null;
    item.is_premium = merchant.is_premium;
    item.merchant_id = merchantId;
    AddToCart(item);
  };
  
  const AddToCart = async(itemcart) => {
    let datacart = getAuthCart();
    let addNew = true;
    if (datacart) {
      if (datacart.items.length > 0) {
        if( datacart?.currency_code &&  datacart?.currency_code !== currency.code ) {
          //alert(`Cannot add redemption in more that one currency.\nActive Currency:${datacart.currency_code}`);
          alert("Empty your cart or complete the transaction before switching currencies.");
          return;
        }
        for (let i in datacart.items) {
          let item = datacart.items[i];
          if (
            item.merchant_id === itemcart.merchant_id &&
            item.sku_value === itemcart.sku_value &&
            item.redemption_value === itemcart.redemption_value
          ) {
            item.qty += 1;
            addNew = false;
          }
        }
      }
    } else {
      datacart = {
        items: [],
        currency_code: currency?.code ?? 'USD'
      };
    }
    if (addNew) {
      itemcart.qty = 1;
      datacart.items.push(itemcart);
      datacart.currency_code = currency?.code ?? 'USD'
    }
    if (updateAuthCart(datacart)) {
      store.dispatch(setCart(datacart));
      setAddedToCart(true);
    }
  };
  
  const Merchant = () => {
    if (!merchant) {
      return <div className="rm-panel__loading">{t("loading_merchant")}</div>;
    }

    const LOGO_PUBLIC_URL = `${process.env.REACT_APP_API_STORAGE_URL}`;
    let giftcodeOptions = [];

    if (giftcodes.length > 0) {
      giftcodeOptions = giftcodes.map((gc, i) => {
        return makeOption(i, gc, program.factor_valuation, currency);
      });
    }

    const isGcm = Boolean(merchant.is_gcm);
    // Checked after filling, so a description that's only an empty {{payload.description}}
    // falls back to the built-in line
    const gcmDescription = isGcm ? fillGcmPlaceholders(merchant.description, merchant) : null;

    return (
      <>
        <div className={`rm-panel__merchant${isGcm ? " rm-panel__merchant--gcm" : ""}`}>
          <div className={`rm-panel__brand${isGcm ? " rm-panel__brand--gcm" : ""}`}>
            <GiftCardImage
              src={gcmPhotoUrl(merchant.image_url) || (merchant.logo ? `${LOGO_PUBLIC_URL}/${merchant.logo}` : "")}
              referrerPolicy="no-referrer"
              name={merchant.name}
            />
            {isGcm && (
              <div className="rm-panel__brand-overlay">
                <span className="rm-panel__brand-name">{merchant.name}</span>
                {merchant.rating > 0 && (
                  <YelpRating
                    className="rm-panel__brand-rating"
                    rating={merchant.rating}
                    reviewCount={merchant.review_count}
                    href={yelpBusinessUrl(merchant)}
                  />
                )}
              </div>
            )}
          </div>

          <div className="rm-panel__content">
            <h3 className="rm-panel__merchant-name">
              {isGcm ? t("gcm_local_gift_card", { name: merchant.name }) : merchant.name}
            </h3>

            {/* GCM: the universal description from the GCM parent merchant (placeholders filled in),
                or the built-in line when none is set */}
            {isGcm && htmlHasText(gcmDescription) ? (
              <div
                className="rm-panel__merchant-desc"
                dangerouslySetInnerHTML={{ __html: gcmDescription }}
              />
            ) : isGcm ? (
              <p className="rm-panel__merchant-desc">
                {t("gcm_gift_card_desc", { name: merchant.name })}
              </p>
            ) : (
              <div
                className="rm-panel__merchant-desc"
                dangerouslySetInnerHTML={{ __html: merchant.description || "" }}
              />
            )}

            {/* GCM businesses have no website of their own, so link to their Yelp page */}
            {(isGcm ? yelpBusinessUrl(merchant) : merchant.website) && (
              <div className="rm-panel__merchant-link-wrap">
                <a target="_blank" rel="noreferrer" href={isGcm ? yelpBusinessUrl(merchant) : `${merchant.website}`}>
                  {t("visit_merchant_website")}
                </a>
              </div>
            )}


            <div className="rm-panel__controls">
              <div className="rm-panel__select">
                {loadingGiftcodes ? (
                  <div className="rm-panel__select-state">{t("loading")}</div>
                ) : giftcodeOptions.length > 0 ? (
                  <Select
                    options={giftcodeOptions}
                    clearable={false}
                    className="react-select"
                    placeholder={" --- "}
                    classNamePrefix="react-select"
                    value={selectedGiftcode}
                    onChange={onChangeGiftcode}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      menu: base => ({ ...base, minWidth: '240px' }),
                    }}
                  />
                ) : (
                  <div className="rm-panel__select-state">{t("no_gift_codes")}</div>
                )}
              </div>

              <div className="rm-panel__actions">
                <TemplateButton
                  type="submit"
                  disabled={!selectedGiftcode}
                  onClick={() => onClickAddToCart()}
                  text={t("add_to_cart")}
                />
              </div>
            </div>

            {addedToCart && (
              <div className="rm-panel__added" role="status">
                <span className="rm-panel__added-text">{t("added_to_cart")}!</span>
                <div className="rm-panel__added-links">
                  <Link to={REDEEM_PATH} className="rm-panel__added-continue">
                    {t("continue_shopping")}
                  </Link>
                  <Link to="/participant/cart" className="mp-btn mp-btn--primary">
                    {t("view_cart_checkout")}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="rm-panel__instructions">
          <div className="rm-panel__instructions-head">
            <h3 className="rm-panel__instructions-title">{t("redemption_instructions")}</h3>
            {/* GCM instructions from the database carry their own challenge-key wording */}
            {!isGcm && <p className="rm-panel__instructions-note">{t("redeem_merchants_desc")}</p>}
          </div>
          {isGcm && (
            <p className="rm-panel__instructions-body">{t("gcm_redemption_instructions")}</p>
          )}
          <div
            className="rm-panel__instructions-body"
            dangerouslySetInnerHTML={{ __html: fillGcmPlaceholders(merchant.redemption_instruction, merchant) || "" }}
          />
        </div>
      </>
    );
  };


  return (
    <section className="rm-panel">
      <div className={`rm-panel__header${merchant?.is_gcm ? " gcm-heading-row" : ""}`}>
        <h2 className="rm-panel__title">{t("get_your_gift_code")}</h2>
        {merchant?.is_gcm && <GcmBrand className="gcm-brand--inline" />}
      </div>
        <Merchant />
    </section>
  );
};

export default connect((state) => ({
  organization: state.organization,
  program: state.program,
  currency: state.currency,
}))(Redeem);
